import React, { useState, useEffect, useRef } from 'react';
import { Label, Input } from '../../../../common/materials';
import { Checkbox } from '@chakra-ui/react';
import { F1PasswordManagement } from 'models/config/F1PasswordManagement';
import Swal, { SweetAlertResult } from 'sweetalert2';

//const REQUIRE_TYPES = ['บังคับระบุตัวอักษรพิมพ์เล็ก', 'บังคับระบุตัวอักษรพิมพ์ใหญ่', 'บังคับระบุตัวเลข', 'บังคับระบุตัวอักษรพิเศษ'] as const;
const REQUIRE_TYPES: { label: string; value: string }[] = [
    { label: 'บังคับระบุตัวอักษรพิมพ์เล็ก', value: 'RequireCharacterLower' },
    { label: 'บังคับระบุตัวอักษรพิมพ์ใหญ่', value: 'RequireCharacterUpper' },
    { label: 'บังคับระบุตัวเลข', value: 'RequireNumber' },
    { label: 'บังคับระบุตัวอักษรพิเศษ', value: 'RequireSpecialCharacter' },
].map(value => ({
    label: value.label,
    value: value.value
}));

//type RequireType = (typeof REQUIRE_TYPES)[number];

type PasswordConfigViewProps = {
    source: F1PasswordManagement | undefined;
    handleChange: (key: string, value: string) => void;
    fireSwal: (title: string, message: string, icon: Parameters<typeof Swal.fire>[2]) => Promise<SweetAlertResult<any>>;
}

function PasswordConfigView(props: PasswordConfigViewProps) {
    const { source, handleChange, fireSwal } = props;

    const inputElementRef_PWDEXPPERIOD = useRef<HTMLInputElement>(null);
    const inputElementRef_AUTOINACTIVE = useRef<HTMLInputElement>(null);
    const inputElementRef_LOGINFAILTIME = useRef<HTMLInputElement>(null);
    const inputElementRef_MINIMUMPWD = useRef<HTMLInputElement>(null);
    const inputElementRef_PWDLENGTH = useRef<HTMLInputElement>(null);
    const inputElementRef_WARNINGEXPPWD = useRef<HTMLInputElement>(null);
    const inputElementRef_ResetPasswordDelay = useRef<HTMLInputElement>(null);
    const inputElementRef_PasswordHistory = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!source) {
            return;
        }

        if (inputElementRef_PWDEXPPERIOD.current) {
            if (source?.PWDEXPPERIOD?.length === 0) {
                inputElementRef_PWDEXPPERIOD.current.style.setProperty('border-color', 'red', 'important');
            } else {
                inputElementRef_PWDEXPPERIOD.current.style.setProperty('border-color', '#D4D4D4');
            }
        }
        if (inputElementRef_AUTOINACTIVE.current) {
            if (source?.AUTOINACTIVE?.length === 0) {
                inputElementRef_AUTOINACTIVE.current.style.setProperty('border-color', 'red', 'important');
            } else {
                inputElementRef_AUTOINACTIVE.current.style.setProperty('border-color', '#D4D4D4');
            }
        }
        if (inputElementRef_LOGINFAILTIME.current) {
            if (source?.LOGINFAILTIME?.toString().length === 0) {
                inputElementRef_LOGINFAILTIME.current.style.setProperty('border-color', 'red', 'important');
            } else {
                inputElementRef_LOGINFAILTIME.current.style.setProperty('border-color', '#D4D4D4');
            }
        }
        if (inputElementRef_MINIMUMPWD.current) {
            if (source?.MINIMUMPWD?.length === 0) {
                inputElementRef_MINIMUMPWD.current.style.setProperty('border-color', 'red', 'important');
            } else {
                inputElementRef_MINIMUMPWD.current.style.setProperty('border-color', '#D4D4D4');
            }
        }
        if (inputElementRef_PWDLENGTH.current) {
            if (source?.PWDLENGTH?.length === 0) {
                inputElementRef_PWDLENGTH.current.style.setProperty('border-color', 'red', 'important');
            } else {
                inputElementRef_PWDLENGTH.current.style.setProperty('border-color', '#D4D4D4');
            }
        }
        if (inputElementRef_WARNINGEXPPWD.current) {
            if (source?.WARNINGEXPPWD?.length === 0) {
                inputElementRef_WARNINGEXPPWD.current.style.setProperty('border-color', 'red', 'important');
            } else {
                inputElementRef_WARNINGEXPPWD.current.style.setProperty('border-color', '#D4D4D4');
            }
        }
        if (inputElementRef_ResetPasswordDelay.current) {
            if (source?.ResetPasswordDelay?.length === 0) {
                inputElementRef_ResetPasswordDelay.current.style.setProperty('border-color', 'red', 'important');
            } else {
                inputElementRef_ResetPasswordDelay.current.style.setProperty('border-color', '#D4D4D4');
            }
        }
        if (inputElementRef_PasswordHistory.current) {
            if (source?.PasswordHistory?.length === 0) {
                inputElementRef_PasswordHistory.current.style.setProperty('border-color', 'red', 'important');
            } else {
                inputElementRef_PasswordHistory.current.style.setProperty('border-color', '#D4D4D4');
            }
        }
    }, [source]);

    const handleChangeWithValidation = (key: string, value: string) => {
        if (value === '' || /^\d+$/.test(value)) {
            handleChange(key, value)
        } else {
            notifyError('กรุณาระบุเฉพาะตัวเลข');
        }
    };

    const notifyError = (message: string) => {
        fireSwal('Error!', message, 'error');
    }

    return (
        <React.Fragment>
            <div className="flex flex-col gap-4 bg-white">
                <div className="grid grid-cols-6 gap-4">
                    <div className="col-span-2 flex flex-col">
                        <Label>รหัสผ่านหมดอายุ (วัน)</Label>
                        <Input
                            ref={inputElementRef_PWDEXPPERIOD}
                            type="text"
                            className="h-[32px] text-right"
                            value={source?.PWDEXPPERIOD ?? '0'}
                            onChange={e => handleChangeWithValidation("PWDEXPPERIOD", e.target.value)}
                            disabled={!source}
                        />
                    </div>
                    <div className="col-span-2 flex flex-col">
                        <Label>ปรับสถานะเมื่อไม่ใช้งาน (วัน)</Label>
                        <Input
                            ref={inputElementRef_AUTOINACTIVE}
                            type="text"
                            className="h-[32px] text-right"
                            value={source?.AUTOINACTIVE ?? '0'}
                            onChange={e => handleChangeWithValidation("AUTOINACTIVE", e.target.value)}
                            disabled={!source}
                        />
                    </div>
                    <div className="col-span-2 flex flex-col">
                        <Label>จำนวนครั้งที่สามารถลงชื่อผิด (ครั้ง)</Label>
                        <Input
                            ref={inputElementRef_LOGINFAILTIME}
                            type="text"
                            className="h-[32px] text-right"
                            value={source?.LOGINFAILTIME ?? 0}
                            onChange={e => handleChangeWithValidation("LOGINFAILTIME", e.target.value)}
                            disabled={!source}
                        />
                    </div>
                    <div className="col-span-2 flex flex-col">
                        <Label>รหัสผ่านขั้นต่ำ (ตัวอักษร)</Label>
                        <Input
                            ref={inputElementRef_MINIMUMPWD}
                            type="text"
                            className="h-[32px] text-right"
                            value={source?.MINIMUMPWD ?? '0'}
                            onChange={e => handleChangeWithValidation("MINIMUMPWD", e.target.value)}
                            disabled={!source}
                        />
                    </div>
                    <div className="col-span-2 flex flex-col">
                        <Label>รหัสผ่านสูงสุด (ตัวอักษร)</Label>
                        <Input
                            ref={inputElementRef_PWDLENGTH}
                            type="text"
                            className="h-[32px] text-right"
                            value={source?.PWDLENGTH ?? '0'}
                            onChange={e => handleChangeWithValidation("PWDLENGTH", e.target.value)}
                            disabled={!source}
                        />
                    </div>
                    <div className="col-span-2 flex flex-col">
                        <Label>แจ้งเตือนรหัสผ่านหมดอายุ (วัน)</Label>
                        <Input
                            ref={inputElementRef_WARNINGEXPPWD}
                            type="text"
                            className="h-[32px] text-right"
                            value={source?.WARNINGEXPPWD ?? '0'}
                            onChange={e => handleChangeWithValidation("WARNINGEXPPWD", e.target.value)}
                            disabled={!source}
                        />
                    </div>
                    <div className="col-span-2 flex flex-col">
                        <Label>เปลี่ยนรหัสผ่านอีกครั้งได้ภายใน (ชั่วโมง)</Label>
                        <Input
                            ref={inputElementRef_ResetPasswordDelay}
                            type="text"
                            className="h-[32px] text-right"
                            value={source?.ResetPasswordDelay ?? '0'}
                            onChange={e => handleChangeWithValidation("ResetPasswordDelay", e.target.value)}
                            disabled={!source}
                        />
                    </div>
                    <div className="col-span-2 flex flex-col">
                        <Label>ไม่สามารถใช้รหัสผ่านซ้ำได้ภายใน (ครั้ง)</Label>
                        <Input
                            ref={inputElementRef_PasswordHistory}
                            type="text"
                            className="h-[32px] text-right"
                            value={source?.PasswordHistory ?? '0'}
                            onChange={e => handleChangeWithValidation("PasswordHistory", e.target.value)}
                            disabled={!source}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-4 gap-4">
                    {/*<div className="col-span-1 flex gap-4">*/}
                    {/*<div className="mt-4 flex flex-col gap-1">*/}
                    <div className="flex flex-col gap-4">
                        <Label>ข้อกำหนดเพิ่มเติม</Label>
                        {REQUIRE_TYPES.map(env => (
                            <Checkbox
                                key={env.value}
                                isChecked={(source?.[env.value])?.toLowerCase() === 'true'}
                                colorScheme="primary"
                                onChange={e => handleChange(env.value, e.target.checked.toString())}
                                disabled={!source}
                            >
                                {env.label}
                            </Checkbox>
                        ))}
                    </div>
                    {/*</div>*/}
                    {/*</div>*/}
                </div>
            </div>
        </React.Fragment>
    );
}

export default PasswordConfigView;